if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.reviewsSection = document.getElementById('reviews-section');
      this.productFormInView = true;
      this.productInfoInView = true;
      this.hasScrolledPastStart = false;
      this.reviewsReached = false;
      this.scrollHandler = this.handleScroll.bind(this);
      this.breakpointChangeHandler = this.updateVisibility.bind(this);

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm) {
            this.productFormInView = entry.boundingClientRect.bottom > 0;
          } else if (entry.target === this.productInfo) {
            this.productInfoInView = entry.isIntersecting;
          }
        });

        this.updateVisibility();
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);
      if (this.reviewsSection) observer.observe(this.reviewsSection);

      window.addEventListener('scroll', this.scrollHandler, { passive: true });
      window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      this.updateVisibility();
    }

    handleScroll() {
      StickyAtcPanel.handleScroll();
      this.updateVisibility();
    }

    updateVisibility() {
      const hideBecauseProductFormIsVisible = theme.mediaMatches.lg
        ? this.productInfoInView
        : this.productFormInView;
      const initialScrollDistance = Math.min(160, window.innerHeight * 0.2);

      this.hasScrolledPastStart = window.scrollY > initialScrollDistance;
      this.reviewsReached = this.reviewsSection
        ? this.reviewsSection.getBoundingClientRect().top <= window.innerHeight
        : false;

      this.classList.toggle(
        'sticky-atc-panel--out',
        !this.hasScrolledPastStart || hideBecauseProductFormIsVisible || this.reviewsReached
      );
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
